<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true}">
        <div class="close" v-on:click="close(false)"></div>
        <h4>Select File Size</h4>
        <div class="loadingCategory" v-if="loading"></div>
        <div class="categoryCnt" v-else>
          <div class="categoryItem"
            v-on:click="copyToClp(media.imageSm); smCopied = true">
            <h5>Small size</h5>
            <p>{{media.imageSm}}</p>
            <button :class="{copied: smCopied}">
              <span v-if="smCopied">Copied</span>
              <span v-else>Copy</span>
            </button>
          </div>
          <div class="categoryItem"
            v-on:click="copyToClp(media.imageMd); mdCopied = true">
            <h5>Medium size</h5>
            <p>{{media.imageMd}}</p>
            <button :class="{copied: mdCopied}">
              <span v-if="mdCopied">Copied</span>
              <span v-else>Copy</span>
            </button>
          </div>
          <div class="categoryItem"
            v-on:click="copyToClp(media.imageLg); lgCopied = true">
            <h5>Large size</h5>
            <p>{{media.imageLg}}</p>
            <button :class="{copied: lgCopied}">
              <span v-if="lgCopied">Copied</span>
              <span v-else>Copy</span>
            </button>
          </div>
        </div>
      </div>
      <Snackbar ref="snackbar"/>
    </div>
  </transition>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'mediaCopy',
  components: { Snackbar },
  data() {
    return {
      show: false,
      next: null,
      media: null,
      mdCopied: false,
      smCopied: false,
      lgCopied: false,
      loading: false,
      btnDisabled: false,
    };
  },
  methods: {
    open(d, next) {
      this.media = d;
      this.show = true;
      this.next = next;
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    copyToClp(txt2copy) {
      setTimeout(() => {
        this.smCopied = false;
        this.mdCopied = false;
        this.lgCopied = false;
      }, 1200);
      const m = document;
      const txt = m.createTextNode(txt2copy);
      const w = window;
      const b = m.body;
      b.appendChild(txt);
      if (b.createTextRange) {
        const d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
      } else {
        const d = m.createRange();
        const g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
      }
      txt.remove();
      this.$refs.snackbar.open({ content: 'Media url copied to clipboard.' });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 380px;
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        opacity: .4;
        cursor: pointer;
        transition: all .2s linear;
      }
      .close:hover{
        background-color: #e5e5e5;
        opacity: .7;
      }
      h4{
        margin: -30px -40px 0;
        padding: 14px 40px 10px;
        border-bottom: #eee 1px solid;
        font-size: 24px;
        font-weight: normal;
        color: #444;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .loadingCategory{
        height: 180px;
        background-image: url(../assets/loading-2.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 40px auto;
      }
      .categoryCnt{
        padding: 26px 0 0;
        .categoryItem{
          margin: 0 -16px;
          padding: 7px 16px 8px;
          padding-right: 100px;
          border-radius: 5px;
          margin-bottom: 5px;
          cursor: pointer;
          border: #eee 1px solid;
          position: relative;
          &:hover{
            background-color: #f5f5fe;
          }
          h5{
            font-weight: normal;
            font-size: 20px;
            margin: 0;
          }
          p{
            margin: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          button{
            background-color: #0057d8;
            color: #fff;
            padding: 5px 12px;
            font-size: 12px;
            border-radius: 50px;
            position: absolute;
            right: 10px; top: 50%;
            transform: translateY(-50%);
            border: none;
            cursor: pointer;
            &:hover{
              background-color: #0067ff;
            }
            &.copied{
              background-color: #ccc;
              color: #999;
            }
          }
          &.active{
            color: #fff;
            background-color: #0057d8;
          }
        }
      }
      p{
        margin: 0;
        color: #767676;
      }
      .checkCnt{
        margin: 20px 0 6px;
        position: relative;
        padding-left: 28px;
        cursor: pointer;
        p{
          color: red;
        }
        .checkboxOuter{
          position: absolute;
          left: -8px; top: -6px;
          width: 32px; height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          &:hover{
            background-color: #eee;
          }
          .checkbox{
            width: 14px; height: 14px;
            border-radius: 3px;
            border: #999 2px solid;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all .2s ease;
            &.checked{
              border-color: red !important;
              background-color: red !important;
              background-image: url(../assets/checked.png);
              background-size: 14px auto;
              background-position: center;
              background-repeat: no-repeat;
              .checkInner{
              }
            }
          }
        }
        &:hover{
          .checkboxOuter{
            .checkbox{
              border-color: #444;
            }
          }
        }
      }
      .modalAction{
        margin: 0 -40px -30px;
        padding: 10px 20px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        .btn{
          margin-left: 10px;
          &.disabled{
            background-color: #ddd;
            color: #999;
            box-shadow: none;
            cursor: default;
          }
        }
      }
    }
  }
</style>
